import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

// ============================================================
// TOUS LES PLACEHOLDERS À REMPLIR PAR L'ÉDITEUR sont marqués [[...]]
// Vous pouvez rechercher "[[" dans ce fichier pour les trouver rapidement.
// ============================================================

// Contact / identité — MODIFIEZ ces constantes une seule fois pour toutes les pages
export const LEGAL_INFO = {
  siteName: 'BcoolStore',
  editorName: 'Tony Wahab AKAKPO',
  editorStatus: 'Auto-entrepreneur',
  editorAddress: '50000 Saint-Lô, France',
  editorSiret: 'En cours d\u2019immatriculation',
  editorEmail: 'tonywahab234@gmail.com',
  publisherName: 'Tony Wahab AKAKPO',
  hostingName: 'OVH SAS',
  hostingAddress: '2 rue Kellermann, 59100 Roubaix, France',
  hostingPhone: '+33 9 72 10 10 07',
  lastUpdate: '09/07/2026',
};

// ============================================================
// Layout commun aux pages légales
// ============================================================
const LegalLayout = ({ title, subtitle, children }) => (
  <main className="max-w-3xl mx-auto px-4 md:px-8 py-14 md:py-20">
    <div className="mb-10 pb-6 border-b border-[#e6ddd0]">
      <div className="text-[11px] uppercase tracking-[0.32em] text-[#c9a961] font-semibold mb-3">
        {subtitle}
      </div>
      <h1
        className="text-[32px] md:text-[42px] font-bold text-[#1a1414] leading-[1.1]"
        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
      >
        {title}
      </h1>
      <p className="text-[12px] text-[#7a716c] mt-3">
        Dernière mise à jour : {LEGAL_INFO.lastUpdate}
      </p>
    </div>
    <div
      className="text-[16px] leading-[1.75] text-[#1a1414] space-y-4"
      style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
    >
      {children}
    </div>
    <div className="mt-12 pt-6 border-t border-[#e6ddd0] text-[13px] text-[#7a716c] flex flex-wrap gap-4">
      <Link to="/mentions-legales" className="hover:text-[#8b2c3f]">Mentions légales</Link>
      <span>·</span>
      <Link to="/politique-confidentialite" className="hover:text-[#8b2c3f]">Politique de confidentialité</Link>
      <span>·</span>
      <Link to="/cookies" className="hover:text-[#8b2c3f]">Politique cookies</Link>
      <span>·</span>
      <Link to="/cgu" className="hover:text-[#8b2c3f]">Conditions d&apos;utilisation</Link>
    </div>
  </main>
);

// Helpers de style pour les h2/h3 dans les pages légales
const H2 = ({ children }) => (
  <h2
    className="text-[24px] font-bold text-[#1a1414] mt-10 mb-4 pb-2 border-b border-[#c9a961]/40 italic"
    style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
  >
    {children}
  </h2>
);

const H3 = ({ children }) => (
  <h3 className="text-[17px] font-bold text-[#1a1414] mt-6 mb-2 uppercase tracking-[0.08em]"
      style={{ fontFamily: "'Inter', sans-serif" }}>
    {children}
  </h3>
);

// ============================================================
// 1. MENTIONS LÉGALES
// ============================================================
export const MentionsLegales = () => (
  <>
    <SEO
      title="Mentions légales"
      description="Mentions légales du site BcoolStore : identité de l'éditeur, hébergeur, propriété intellectuelle."
      url="/mentions-legales"
    />
    <LegalLayout title="Mentions légales" subtitle="Information légale">
      <p>
        Le présent site <strong>{LEGAL_INFO.siteName}</strong> est édité conformément aux
        dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l&apos;économie
        numérique (dite « LCEN »).
      </p>

      <H2>Éditeur du site</H2>
      <p>
        <strong>Nom :</strong> {LEGAL_INFO.editorName}<br />
        <strong>Statut :</strong> {LEGAL_INFO.editorStatus}<br />
        <strong>Adresse :</strong> {LEGAL_INFO.editorAddress}<br />
        <strong>SIRET / RCS :</strong> {LEGAL_INFO.editorSiret}<br />
        <strong>Contact :</strong>{' '}
        <a href={`mailto:${LEGAL_INFO.editorEmail}`} className="text-[#8b2c3f] underline">
          {LEGAL_INFO.editorEmail}
        </a>
      </p>

      <H2>Directeur de la publication</H2>
      <p>{LEGAL_INFO.publisherName}</p>

      <H2>Hébergement</H2>
      <p>
        Ce site est hébergé par : <strong>{LEGAL_INFO.hostingName}</strong><br />
        {LEGAL_INFO.hostingAddress}<br />
        Téléphone : {LEGAL_INFO.hostingPhone}
      </p>

      <H2>Propriété intellectuelle</H2>
      <p>
        L&apos;ensemble des contenus publiés sur {LEGAL_INFO.siteName} (textes, images,
        illustrations, logo, mise en page, code source) est la propriété exclusive de
        l&apos;éditeur ou de ses partenaires, protégée par le droit d&apos;auteur (articles
        L.111-1 et suivants du Code de la propriété intellectuelle).
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, adaptation, totale ou
        partielle, sur quelque support que ce soit, sans autorisation écrite préalable, est
        strictement interdite et constitue une contrefaçon (article L.335-2 du Code de la
        propriété intellectuelle).
      </p>

      <H2>Responsabilité éditoriale</H2>
      <p>
        L&apos;éditeur met tout en œuvre pour offrir aux utilisateurs des informations
        vérifiées. Toutefois, il ne saurait être tenu responsable des erreurs, omissions ou
        des conséquences d&apos;une utilisation des informations mises à disposition.
      </p>
      <p>
        Les histoires publiées sont des œuvres de fiction originales inspirées de situations
        universelles. Toute ressemblance avec des personnes réelles ou des situations
        existantes serait purement fortuite.
      </p>

      <H2>Liens hypertextes</H2>
      <p>
        Les liens externes présents sur {LEGAL_INFO.siteName} redirigent vers des sites tiers
        dont l&apos;éditeur ne maîtrise pas le contenu. Il ne saurait être tenu responsable
        des pratiques ni des contenus de ces sites.
      </p>

      <H2>Droit applicable</H2>
      <p>
        Les présentes mentions légales sont régies par le droit français. En cas de litige,
        les tribunaux français seront seuls compétents.
      </p>
    </LegalLayout>
  </>
);

// ============================================================
// 2. POLITIQUE DE CONFIDENTIALITÉ (RGPD)
// ============================================================
export const PolitiqueConfidentialite = () => (
  <>
    <SEO
      title="Politique de confidentialité"
      description="Comment BcoolStore collecte, utilise et protège vos données personnelles conformément au RGPD."
      url="/politique-confidentialite"
    />
    <LegalLayout title="Politique de confidentialité" subtitle="Protection des données">
      <p>
        La présente politique explique quelles données personnelles nous collectons, pourquoi
        nous les utilisons, à qui elles peuvent être transmises et quels sont vos droits,
        conformément au Règlement Général sur la Protection des Données (RGPD) et à la Loi
        Informatique et Libertés.
      </p>

      <H2>1. Responsable du traitement</H2>
      <p>
        Le responsable du traitement des données personnelles est :<br />
        <strong>{LEGAL_INFO.editorName}</strong> ({LEGAL_INFO.editorStatus})<br />
        {LEGAL_INFO.editorAddress}<br />
        Contact :{' '}
        <a href={`mailto:${LEGAL_INFO.editorEmail}`} className="text-[#8b2c3f] underline">
          {LEGAL_INFO.editorEmail}
        </a>
      </p>

      <H2>2. Données collectées et finalités</H2>
      <p>Nous collectons les données suivantes, uniquement pour les finalités précisées :</p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>
          <strong>Adresse email</strong> : lors de l&apos;inscription à la newsletter,
          uniquement pour vous envoyer nos publications.
        </li>
        <li>
          <strong>Données de navigation</strong> (adresse IP, pages consultées, durée) :
          statistiques anonymes d&apos;audience, avec votre consentement uniquement.
        </li>
        <li>
          <strong>Cookies publicitaires</strong> : pour afficher des publicités adaptées, avec
          votre consentement uniquement.
        </li>
        <li>
          <strong>Contenu librement fourni</strong> (récits envoyés par email) : uniquement
          pour envisager une publication, jamais partagés sans votre accord.
        </li>
      </ul>

      <H2>3. Base légale du traitement</H2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Consentement</strong> (art. 6.1.a RGPD) : newsletter, cookies non essentiels.</li>
        <li><strong>Intérêt légitime</strong> (art. 6.1.f RGPD) : sécurité du site, mesure d&apos;audience anonyme.</li>
        <li><strong>Obligation légale</strong> (art. 6.1.c RGPD) : conservation des logs de sécurité.</li>
      </ul>

      <H2>4. Durée de conservation</H2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Email newsletter : jusqu&apos;à votre désinscription + 12 mois.</li>
        <li>Cookies de mesure d&apos;audience : 13 mois maximum (recommandation CNIL).</li>
        <li>Cookies publicitaires : selon le partenaire (max 13 mois).</li>
        <li>Logs techniques : 12 mois maximum.</li>
      </ul>

      <H2>5. Destinataires</H2>
      <p>
        Vos données ne sont jamais vendues. Elles peuvent être partagées avec nos
        sous-traitants techniques strictement nécessaires (hébergeur, service d&apos;envoi
        newsletter, régie publicitaire), tous liés par un contrat de confidentialité et le
        RGPD.
      </p>

      <H2>6. Vos droits</H2>
      <p>Conformément aux articles 15 à 22 du RGPD, vous disposez à tout moment :</p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>D&apos;un <strong>droit d&apos;accès</strong> à vos données.</li>
        <li>D&apos;un <strong>droit de rectification</strong> en cas d&apos;erreur.</li>
        <li>D&apos;un <strong>droit d&apos;effacement</strong> (« droit à l&apos;oubli »).</li>
        <li>D&apos;un <strong>droit d&apos;opposition</strong> et de <strong>limitation</strong>.</li>
        <li>D&apos;un <strong>droit à la portabilité</strong> de vos données.</li>
        <li>Du droit de <strong>retirer votre consentement</strong> à tout moment.</li>
      </ul>
      <p className="mt-3">
        Pour exercer ces droits, écrivez-nous à :{' '}
        <a href={`mailto:${LEGAL_INFO.editorEmail}`} className="text-[#8b2c3f] underline">
          {LEGAL_INFO.editorEmail}
        </a>
        . Nous répondons dans un délai maximum d&apos;un mois.
      </p>

      <H2>7. Réclamation</H2>
      <p>
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez adresser une
        réclamation à la CNIL :{' '}
        <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-[#8b2c3f] underline">
          www.cnil.fr
        </a>
      </p>
    </LegalLayout>
  </>
);

// ============================================================
// 3. POLITIQUE COOKIES
// ============================================================
export const PolitiqueCookies = () => (
  <>
    <SEO
      title="Politique cookies"
      description="Types de cookies utilisés sur BcoolStore et comment gérer votre consentement."
      url="/cookies"
    />
    <LegalLayout title="Politique cookies" subtitle="Gestion des traceurs">
      <p>
        Un cookie est un petit fichier texte déposé sur votre appareil lors de votre visite,
        qui permet de reconnaître votre navigateur et de conserver certaines informations. Le
        site {LEGAL_INFO.siteName} utilise différentes catégories de cookies décrites
        ci-dessous. Vous gardez le contrôle à tout moment.
      </p>

      <H2>1. Cookies strictement nécessaires</H2>
      <p>
        Ces cookies sont indispensables au fonctionnement du site (mémorisation de vos
        préférences de consentement, sécurité, session). Ils ne peuvent pas être désactivés.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><code>bcool_cookie_consent_v1</code> — mémoire de votre choix de consentement (13 mois).</li>
      </ul>

      <H2>2. Cookies de mesure d&apos;audience</H2>
      <p>
        Avec votre accord, nous mesurons de manière anonyme le nombre de visites, les pages
        les plus lues et la durée moyenne. Cela nous aide à améliorer le site.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Google Analytics 4</strong> — cookies <code>_ga</code>, <code>_gid</code> (13 mois max).</li>
      </ul>

      <H2>3. Cookies publicitaires</H2>
      <p>
        Avec votre accord, nos régies publicitaires déposent des cookies pour vous proposer
        des publicités adaptées à vos centres d&apos;intérêt et mesurer leur performance.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Google AdSense / Google Ads</strong> (partenaire publicitaire).</li>
        <li>Autres partenaires publicitaires ponctuels (liste à venir).</li>
      </ul>

      <H2>4. Gérer vos préférences</H2>
      <p>
        Vous pouvez à tout moment modifier votre choix en cliquant sur le lien
        « <em>Gérer les cookies</em> » présent en bas de page, ou en vidant le stockage local
        de votre navigateur. Vous pouvez également refuser tous les cookies non essentiels
        directement depuis les réglages de votre navigateur.
      </p>

      <H2>5. Durée de conservation du consentement</H2>
      <p>
        Votre choix (accepter, refuser ou personnaliser) est conservé pendant <strong>13 mois</strong>,
        conformément aux recommandations de la CNIL. Passé ce délai, la bannière vous sera
        re-présentée.
      </p>
    </LegalLayout>
  </>
);

// ============================================================
// 4. CONDITIONS GÉNÉRALES D'UTILISATION
// ============================================================
export const CGU = () => (
  <>
    <SEO
      title="Conditions générales d'utilisation"
      description="Les règles de bonne conduite pour utiliser le site BcoolStore."
      url="/cgu"
    />
    <LegalLayout title="Conditions d'utilisation" subtitle="Règles du site">
      <p>
        L&apos;accès et l&apos;utilisation du site {LEGAL_INFO.siteName} impliquent
        l&apos;acceptation sans réserve des présentes conditions générales d&apos;utilisation
        (CGU). Si vous n&apos;acceptez pas ces conditions, veuillez ne pas utiliser le site.
      </p>

      <H2>1. Objet du site</H2>
      <p>
        {LEGAL_INFO.siteName} est un site éditorial francophone qui publie des récits
        originaux, chroniques et confidences autour des relations humaines, de la famille et
        de l&apos;art de vivre. Le site est accessible gratuitement.
      </p>

      <H2>2. Accès au site</H2>
      <p>
        L&apos;accès au site est libre et gratuit. L&apos;éditeur se réserve le droit
        d&apos;interrompre, temporairement ou définitivement, tout ou partie du site,
        notamment pour des raisons de maintenance ou d&apos;évolution.
      </p>

      <H2>3. Comportement de l&apos;utilisateur</H2>
      <p>Vous vous engagez, en tant qu&apos;utilisateur, à :</p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Ne pas tenter d&apos;accéder à des zones réservées (interface admin).</li>
        <li>Ne pas copier ou reproduire les contenus sans autorisation écrite préalable.</li>
        <li>Ne pas envoyer de contenus illicites, diffamants ou portant atteinte aux droits de tiers.</li>
        <li>Respecter les autres utilisateurs et l&apos;équipe éditoriale.</li>
      </ul>

      <H2>4. Contributions de lecteurs</H2>
      <p>
        Si vous nous envoyez un récit par email, vous nous accordez le droit non exclusif de
        le publier sur {LEGAL_INFO.siteName}, en tout ou partie, éventuellement retouché pour
        des raisons éditoriales, sous pseudonyme ou anonymat si vous le souhaitez.
      </p>

      <H2>5. Publicité</H2>
      <p>
        {LEGAL_INFO.siteName} peut afficher des publicités et des liens d&apos;affiliation
        pour financer son fonctionnement. Ces contenus sont clairement identifiables. Nous ne
        recommandons pas explicitement les produits ou services promus par ces publicités.
      </p>

      <H2>6. Limitation de responsabilité</H2>
      <p>
        L&apos;éditeur met tout en œuvre pour assurer la disponibilité et l&apos;exactitude
        du site, sans pouvoir toutefois garantir l&apos;absence totale d&apos;erreurs ou
        d&apos;interruptions. Sa responsabilité ne saurait être engagée en cas de dommages
        indirects.
      </p>

      <H2>7. Modification des CGU</H2>
      <p>
        L&apos;éditeur peut modifier ces CGU à tout moment. Les modifications s&apos;appliquent
        dès leur publication sur cette page. Nous vous invitons à les consulter régulièrement.
      </p>

      <H2>8. Droit applicable</H2>
      <p>
        Les présentes CGU sont régies par le droit français. Tout litige relatif à leur
        interprétation ou à leur exécution relève des tribunaux français compétents.
      </p>
    </LegalLayout>
  </>
);
